
<div class="flow-cloud-source-card" :selected="selected" @click="handleClick($event)">
	<div class="flow-cloud-source-card-header">
		<slot name="header" />
	</div>
	<div class="flow-cloud-source-card-content">
		<slot />
	</div>
</div>
